import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-vendor-detail-modal',
  templateUrl: './vendor-detail-modal.component.html',
  styleUrls: ['./vendor-detail-modal.component.css']
})
export class VendorDetailModalComponent implements OnInit {

  @Input() vendorDetail: any;
  @Output() closeModal = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
